import React, { PureComponent } from "react";
import { Route } from "react-router-dom";
import { Header } from "../../component";
import { CircleArrow as ScrollUpButton } from "react-scroll-up-button";
import { PATHS } from "../../constant";
import Footer from "../../container/front/Footer";
import {
  getArticleNotFound,
  subscribeArticleNotFound
} from "../../container/articleDetail/articleSlug";
class CommonLayout extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      notificationFlag: false,
      taskID: "",
      success: false,
      formName: null,
      toName: null,
      articleNotFound: getArticleNotFound()
    };
  }
  componentDidMount() {
    this.unsubscribeNotFound = subscribeArticleNotFound(value =>
      this.setState({ articleNotFound: value })
    );
  }
  componentWillUnmount() {
    this.unsubscribeNotFound && this.unsubscribeNotFound();
  }
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }
  handleNotficationflag = data => {
    this.setState({ notificationFlag: data });
  };
  handleTaskID = (data, formName, toName) => {
    this.setState({ taskID: data, formName: formName, toName: toName });
  };
  migrationAPICall = flag => {
    this.setState({ success: flag });
  };
  render() {
    const {
      notificationFlag,
      component: Component,
      location: { pathname },
      ...rest
    } = this.props;
    const { articleNotFound } = this.state;
    const { location } = this.props;
    const isBestPracticesPage = pathname === PATHS.BEST_PRACTICES;
    const isArticleDetailsPage = pathname.startsWith(
      PATHS.ARTICLES_DETAILS_PAGE
    );
    const isAboutUsPage = pathname.startsWith(PATHS.ABOUT_US_PAGE);
    const isContactUsPage = pathname.startsWith(PATHS.CONTACT_US_PAGE);
    const isFeedBackPage = pathname.startsWith(PATHS.FEEDBACK_PAGE);
    const isSiteMapPage = pathname.startsWith(PATHS.SITEMAP);
    const isPublicResourcePage =
      isBestPracticesPage ||
      isArticleDetailsPage ||
      isAboutUsPage ||
      isContactUsPage ||
      isFeedBackPage ||
      isSiteMapPage;
    if (location.pathname !== PATHS.MIS) {
      if (window.axios_source && window.axios_source.length) {
        window.axios_source.forEach(source => {
          source.cancel("Operation canceled");
        });
      }
    }
    window.axios_source = [];

    return (
      <Route
        {...rest}
        render={matchProps => (
          <React.Fragment>
            <div
              className={`root-wrapper ${
                pathname === PATHS.HOME || isPublicResourcePage
                  ? "front-page"
                  : ""
              } ${isArticleDetailsPage ? "article-details-layout" : ""}`}
            >
              <Header
                migrationAPICall={this.migrationAPICall}
                notificationFlag={this.state.notificationFlag}
                taskID={this.state.taskID}
                toName={this.state.toName}
                formName={this.state.formName}
              />
              <div
                className={`${
                  isBestPracticesPage
                    ? "best-practices-main-container"
                    : isArticleDetailsPage
                    ? "article-details-main-container"
                    : "main-container"
                }`}
                style={
                  articleNotFound
                    ? { minHeight: "calc(80% - 91px)" }
                    : undefined
                }
              >
                <Component
                  onChange={this.handleNotficationflag}
                  handleTaskID={this.handleTaskID}
                  success={this.state.success}
                  {...rest}
                  {...matchProps}
                />
              </div>
              <Footer />
              <ScrollUpButton />
            </div>
          </React.Fragment>
        )}
      />
    );
  }
}

export default CommonLayout;
